import vlog from '../../javascript/vlog';

const setFollowStatus = async ({
  followableType,
  followableId,
  profileId,
  status,
  forceFollow = null,
  setIsActionLoading,
  callback = null,
  currentPage = 1,
  onlyUpdateForceFollow = false,
  authenticatedHeadersHash,
}) => {
  setIsActionLoading(true); // Start spinner
  let success = false;
  const data = {
    data: {
      attributes: {
        profile_id: profileId,
        followable_type: followableType,
        followable_id: followableId,
      },
    },
  };

  // If we're only updating force_follow status without changing follow_status
  if (onlyUpdateForceFollow) {
    data.data.attributes.force_follow = forceFollow;
  } else {
    // Otherwise set both follow_status and optionally force_follow
    data.data.attributes.follow_status = status;

    if (forceFollow === true) {
      data.data.attributes.force_follow = true;
    } else if (forceFollow === false) {
      data.data.attributes.force_follow = false;
    }
  }

  try {
    const response = await fetch(`${window.V2_URL}/match_feed/api/follows`, {
      method: 'POST',
      headers: new Headers({
        ...authenticatedHeadersHash,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    });

    if (response.ok) {
      success = true;
      // Don't refresh tab - leave the row in the table as a UI convenience
    } else {
      const errorText = await response.text();
      vlog.error(`Error setting hashtag to ${status}:`, response.statusText, errorText);
      throw new Error('Network response was not ok.');
    }
  } catch (err) {
    vlog.error(`Error setting hashtag to ${status}:`, err);
  } finally {
    setIsActionLoading(false); // Stop spinner
  }

  if (success && callback) {
    callback(currentPage, true);
  }

  return success;
};

export default setFollowStatus;
